import { render, staticRenderFns } from "./ContratosSigaBase.vue?vue&type=template&id=6dc5d210&"
import script from "./ContratosSigaBase.vue?vue&type=script&lang=ts&"
export * from "./ContratosSigaBase.vue?vue&type=script&lang=ts&"
import style0 from "./ContratosSigaBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6dc5d210', component.options)
    } else {
      api.reload('6dc5d210', component.options)
    }
    module.hot.accept("./ContratosSigaBase.vue?vue&type=template&id=6dc5d210&", function () {
      api.rerender('6dc5d210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/ContratosSiga/ContratosSigaBase.vue"
export default component.exports